import React from 'react';
import { useAuth } from '../hooks/useAuth';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import styles from '../pages/Home.module.css';  

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, user } = useAuth();
  const [isCheckingRole, setIsCheckingRole] = React.useState(true);
  const [hasRequiredRole, setHasRequiredRole] = React.useState(false);

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  React.useEffect(() => {
    if (user) {
      const roles = user['https://prodagen.com/roles'] as string[] || [];
      const username = user['https://prodagen.com/username'] as string;
      console.log('User roles:', roles);
      console.log('Username:', username);
      setHasRequiredRole(roles.includes('ProdagenUser'));
      setIsCheckingRole(false);
    }
  }, [user]);

  if (isLoading || isCheckingRole) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return null; // Will redirect in useEffect
  }

  if (!hasRequiredRole) {
    return (
      <div className={styles.errorContainer}>
        <div>User not authorized for this application</div>
        <div>Please contact your administrator for access.</div>
      </div>
    );
  }

  return <Component />;
};
